import Particles, { initParticlesEngine } from "@tsparticles/react"
import { loadSlim } from "@tsparticles/slim"
import { useEffect, useState } from "react";
import particleconfig from "../components/config/particles-config";
import SiteHeader from '../components/SiteHeader';
import "../components/css/Projects.css"
import projects from "../projects.json"
import googlePlay from "../images/googlePlay.png"
import appStore from "../images/appStore.png"

export default function ProjectsPage() {

    const [init, setInit] = useState(false);

    useEffect(() => {
      initParticlesEngine(async (engine) => {
        await loadSlim(engine);
      }).then(() => {
        setInit(true);
      })
    }, []);
  
    const particlesLoaded = (container) => {
      console.log("Particles loaded:", container);
    };
  
    return (
      <div className="App">
        <SiteHeader />
        <div className="wrapper">
        <div className="Projects">
          <h1>Projects</h1>
          <p>Here are some notable projects</p>
          <ul style={{paddingLeft: 0}}>
            {projects.map((project) => {
              return (
                <li key={project.name} className="list-item">
                  <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                    <img src={project.image_url} width={128} height={128} alt="Game Icon"/>
                    <div style={{textAlign: "left", paddingLeft: 10}}>
                    <h2>{project.name} ({project.year})</h2>
                    <p>{project.description}</p>
                    </div>
                    <div className="platforms">
                      {project.platforms.includes("GooglePlay") && (<img src={googlePlay} className="google" alt="Get it on Google Play"/>)}
                      {project.platforms.includes("AppStore") && (<img src={appStore} className="appstore" alt="Download it on the App Store"/>)}
                    </div>
                  </div>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
        {init && (<Particles id="tsparticles" options={particleconfig} particlesLoaded={particlesLoaded}></Particles>)}
      </div>
    );
  }